module.exports = __webpack_public_path__ + "static/4-bbf4d4da30f2c70b0e9e7b101e81752e.jpg";